var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.userInfo.extNo != null,
          expression: "userInfo.extNo != null"
        }
      ],
      ref: "div",
      staticClass: "ys-float-btn",
      style: {
        width: "720px",
        height: "48px",
        left: _vm.left + "px",
        top: _vm.top + "px"
      }
    },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticStyle: { "text-align": "center" }, attrs: { span: 2 } },
            [
              _c(
                "div",
                {
                  staticClass: "status",
                  on: {
                    click: function($event) {
                      return _vm.handle_Cti_Login()
                    }
                  }
                },
                [_c("svg-icon", { attrs: { "icon-class": _vm.status_icon } })],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("el-col", { staticClass: "title", attrs: { span: 7 } }, [
            _c("div", [
              _vm.statusTxt == "响铃中"
                ? _c("img", {
                    attrs: { src: require("@/assets/image/ringing.gif") }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.statusTxt == "通话中"
                ? _c("img", {
                    attrs: { src: require("@/assets/image/talking.gif") }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "f13",
                  class: {
                    alert:
                      _vm.statusTxt == "话后" ||
                      _vm.statusTxt == "响铃中" ||
                      _vm.statusTxt == "未登录"
                  }
                },
                [_vm._v(_vm._s(_vm.title))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "timer" }, [
              _vm._v(_vm._s(_vm._f("durationFilter")(_vm.timer_num)) + " "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.statusTxt.indexOf("中") >= 0,
                      expression: "statusTxt.indexOf('中') >= 0"
                    }
                  ]
                },
                [_vm._v(_vm._s(_vm.call.city))]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 5 } },
            [
              _c(
                "el-input",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showDialOutBtn,
                      expression: "showDialOutBtn"
                    }
                  ],
                  staticClass: "inputMobile",
                  attrs: {
                    id: "txt_callout",
                    maxlength: "12",
                    disabled: !_vm.status_login,
                    type: "text",
                    size: "mini",
                    placeholder: "请输入拨打号码"
                  },
                  model: {
                    value: _vm.call.mobile,
                    callback: function($$v) {
                      _vm.$set(_vm.call, "mobile", $$v)
                    },
                    expression: "call.mobile"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-call",
                      attrs: { slot: "suffix", size: "mini", type: "text" },
                      on: {
                        click: function($event) {
                          return _vm.callCicEvent("dialOut", null)
                        }
                      },
                      slot: "suffix"
                    },
                    [
                      _c("svg-icon", {
                        staticClass: "svg svg-call",
                        attrs: { "icon-class": "call-out" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            {
              staticStyle: { display: "flex", "justify-content": "flex-end" },
              attrs: { span: 8 }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.statusTxt == "响铃中" && _vm.call.callType == "IIB",
                      expression:
                        "statusTxt == '响铃中' && call.callType == 'IIB'"
                    }
                  ],
                  staticClass: "div",
                  on: {
                    click: function($event) {
                      return _vm.callCicEvent("accept", null)
                    }
                  }
                },
                [
                  _c("svg-icon", {
                    staticClass: "svg",
                    attrs: { "icon-class": "call_acc" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "span" }, [_vm._v("接听")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.statusTxt == "通话中" && _vm.call.isHold == false,
                      expression:
                        "statusTxt == '通话中' && call.isHold == false"
                    }
                  ],
                  staticClass: "div",
                  on: {
                    click: function($event) {
                      return _vm.callCicEvent("hold", null)
                    }
                  }
                },
                [
                  _c("svg-icon", {
                    staticClass: "svg",
                    attrs: { "icon-class": "call_mute" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "span" }, [_vm._v("保留")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.call.isHold == true,
                      expression: "call.isHold == true"
                    }
                  ],
                  staticClass: "div",
                  on: {
                    click: function($event) {
                      return _vm.callCicEvent("unhold", null)
                    }
                  }
                },
                [
                  _c("svg-icon", {
                    staticClass: "svg",
                    attrs: { "icon-class": "call_mute_r" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "span" }, [_vm._v("接回")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.call.tranferStatus == "connected",
                      expression: "call.tranferStatus == 'connected'"
                    }
                  ],
                  staticClass: "div",
                  on: {
                    click: function($event) {
                      return _vm.callCicEvent("tranferOk", null)
                    }
                  }
                },
                [
                  _c("svg-icon", {
                    staticClass: "svg",
                    attrs: { "icon-class": "call_tran_ok" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "span" }, [_vm._v("确认转接")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.call.tranferStatus == "connected" ||
                        _vm.call.tranferStatus == "talking",
                      expression:
                        "call.tranferStatus == 'connected' || call.tranferStatus == 'talking'"
                    }
                  ],
                  staticClass: "div",
                  on: {
                    click: function($event) {
                      return _vm.callCicEvent("tranferCancel", null)
                    }
                  }
                },
                [
                  _c("svg-icon", {
                    staticClass: "svg",
                    attrs: { "icon-class": "call_tran_cancel" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "span" }, [_vm._v("取消转接")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dropdown",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.statusTxt == "通话中",
                      expression: "statusTxt == '通话中'"
                    }
                  ]
                },
                [
                  _c(
                    "div",
                    { staticClass: "div" },
                    [
                      _c("svg-icon", {
                        staticClass: "svg",
                        attrs: { "icon-class": "call_tran" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "span" }, [_vm._v("转接")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    _vm._l(_vm.userExtList, function(ext) {
                      return _c("el-dropdown-item", [
                        _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                return _vm.callCicEvent("tranfer", ext.extNo)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(ext.userName) + " " + _vm._s(ext.extNo)
                            )
                          ]
                        )
                      ])
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.statusTxt == "通话中",
                      expression: "statusTxt == '通话中'"
                    }
                  ],
                  staticClass: "div",
                  on: {
                    click: function($event) {
                      return _vm.callCicEvent("tranferIvr", null)
                    }
                  }
                },
                [
                  _c("svg-icon", {
                    staticClass: "svg",
                    attrs: { "icon-class": "call_my" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "span" }, [_vm._v("满意度")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.statusTxt == "通话中" && _vm.user.userType == 0,
                      expression: "statusTxt == '通话中' && user.userType == 0"
                    }
                  ],
                  staticClass: "div",
                  on: {
                    click: function($event) {
                      return _vm.callCicEvent("addTicket", null)
                    }
                  }
                },
                [
                  _c("svg-icon", {
                    staticClass: "svg",
                    attrs: { "icon-class": "call_add" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "span" }, [_vm._v("工单弹屏")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.statusTxt == "通话中" || _vm.statusTxt == "响铃中",
                      expression:
                        "statusTxt == '通话中' || statusTxt == '响铃中'"
                    }
                  ],
                  staticClass: "div",
                  on: {
                    click: function($event) {
                      return _vm.callCicEvent("hangup", null)
                    }
                  }
                },
                [
                  _c("svg-icon", {
                    staticClass: "svg",
                    staticStyle: { fill: "red !important" },
                    attrs: { "icon-class": "call-hangup" }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "span", staticStyle: { color: "red" } },
                    [_vm._v("挂断")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 2 } },
            [
              _c(
                "el-dropdown",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.status_login &&
                        (_vm.statusTxt == "空闲" ||
                          _vm.statusTxt == "话后中" ||
                          (_vm.statusTxt && _vm.statusTxt.indexOf("中") < 0)),
                      expression:
                        "status_login && (statusTxt == '空闲' || statusTxt == '话后中' || statusTxt && statusTxt.indexOf('中') < 0)"
                    }
                  ],
                  staticClass: "avatar-container right-menu-item",
                  attrs: { trigger: "click" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "div",
                      staticStyle: { "flex-direction": "row" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column"
                          }
                        },
                        [
                          _c("svg-icon", {
                            staticClass: "svg svg-rest",
                            staticStyle: { color: "white" },
                            attrs: { "icon-class": _vm.ctiRest.icon }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "span",
                              staticStyle: { color: "#671E75" }
                            },
                            [_vm._v(_vm._s(_vm.ctiRest.title))]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "el-icon-caret-bottom",
                        staticStyle: { color: "#671E75" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c("el-dropdown-item", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.statusCti != "free",
                                expression: "statusCti != 'free'"
                              }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.callCicEvent("changeStatus", "free")
                              }
                            }
                          },
                          [
                            _c("svg-icon", {
                              staticClass: "svg svg-rest",
                              attrs: { "icon-class": "call-ready" }
                            }),
                            _vm._v("\n              示闲\n            ")
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("el-dropdown-item", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ctiRest.title != "培训",
                                expression: "ctiRest.title != '培训'"
                              }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.callCicEvent(
                                  "changeStatus",
                                  "training"
                                )
                              }
                            }
                          },
                          [
                            _c("svg-icon", {
                              staticClass: "svg svg-rest",
                              attrs: { "icon-class": "call-meeting" }
                            }),
                            _vm._v("\n              培训\n            ")
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("el-dropdown-item", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ctiRest.title != "小休",
                                expression: "ctiRest.title != '小休'"
                              }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.callCicEvent("changeStatus", "break")
                              }
                            }
                          },
                          [
                            _c("svg-icon", {
                              staticClass: "svg svg-rest",
                              attrs: { "icon-class": "call-training" }
                            }),
                            _vm._v("\n              小休\n            ")
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("el-dropdown-item", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ctiRest.title != "午餐",
                                expression: "ctiRest.title != '午餐'"
                              }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.callCicEvent("changeStatus", "meal")
                              }
                            }
                          },
                          [
                            _c("svg-icon", {
                              staticClass: "svg svg-rest",
                              attrs: { "icon-class": "call-rest" }
                            }),
                            _vm._v("\n              午餐\n            ")
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("el-dropdown-item", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.statusTxt == "话后" ||
                                  _vm.statusCti != "callout",
                                expression:
                                  "statusTxt == '话后' || statusCti != 'callout'"
                              }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.callCicEvent(
                                  "changeStatus",
                                  "callout"
                                )
                              }
                            }
                          },
                          [
                            _c("svg-icon", {
                              staticClass: "svg svg-rest",
                              attrs: { "icon-class": "call-out" }
                            }),
                            _vm._v("\n              外拨\n            ")
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("el-dropdown-item", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.statusTxt != "话后",
                                expression: "statusTxt != '话后'"
                              }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.callCicEvent("changeStatus", "after")
                              }
                            }
                          },
                          [
                            _c("svg-icon", {
                              staticClass: "svg svg-rest",
                              attrs: { "icon-class": "call-locked" }
                            }),
                            _vm._v("\n              ACW\n            ")
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("AiAgent", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.status_login,
            expression: "status_login"
          }
        ]
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }